<script>
import useVuelidate from '@vuelidate/core';
import {requiredIf} from '@vuelidate/validators';

/* COMPOSANTS */
import AkInputTextArea from '@components/v2/input/AkInputTextArea.vue';
import AkInputMoney from '@components/v2/input/AkInputMoney.vue';

/* MIXINS */

export default {
  components: {AkInputMoney, AkInputTextArea},
  props: {
    modelValue: {
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    showPriceInput: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  mixins: [],
  validations() {
    return {
      currentValue: {
        priceHt: {required: requiredIf(this.showPriceInput)},
        commentForParticipant: {},
      },
    };
  },
  mounted() {},
  setup() {
    return {v$: useVuelidate()};
  },
  data() {
    return {};
  },
  computed: {
    currentValue: {
      get: function () {
        return this.modelValue;
      },
      set: function (val) {
        this.$emit('update:modelValue', val);
      },
    },
  },
  methods: {},
};
</script>

<template>
  <AkInputMoney
    v-if="this.showPriceInput"
    v-model="currentValue.priceHt"
    :label="this.$t('mission_order.offer_price') + (index + 1)"
    :placeholder="this.$t('mission_order.offer_price') + (index + 1)"
    :validator="v$.currentValue.priceHt"
    :min="0" />
  <AkInputTextArea
    v-model="currentValue.commentForParticipant"
    :label="this.$t('mission_order.comment_on_offer') + (index + 1)"
    :placeholder="this.$t('mission_order.comment_on_offer') + (index + 1)"
    :validator="v$.currentValue.commentForParticipant"
    :rows="4" />
</template>
